export const ROUTES = {
	HOME: '/',
	LOGIN: '/login',
	CALL: '/call',
	CALL_ROOM: '/call/rooms/:id',
} as const;
